import Axios from 'axios';
import Qs from 'qs';

export default {

  // 户型分页列表
  listPage(
    community_id,
    name,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/housing-type', {
      params: {
        filter: {
          name
        },
        sort: {
          id: 'desc'
        },
        community_id,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加户型
  add(
    community_id,
    name,
    build_area,
    use_area,
    public_area,
    gift_area,
    room,
    hall,
    toilet
  ) {
    return Axios.post('/community/api/admin/housing-type', {
      community_id,
      name,
      build_area,
      use_area,
      public_area,
      gift_area,
      room,
      hall,
      toilet
    });
  },

  // 编辑户型
  edit(
    id,
    community_id,
    name,
    build_area,
    use_area,
    public_area,
    gift_area,
    room,
    hall,
    toilet
  ) {
    return Axios.patch(`/community/api/admin/housing-type/${id}`, {
      community_id,
      name,
      build_area,
      use_area,
      public_area,
      gift_area,
      room,
      hall,
      toilet
    });
  },

  // 删除户型
  del(
    id
  ) {
    return Axios.delete(`/community/api/admin/housing-type/${id}`);
  },

  // 户型信息
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/housing-type/${id}`);
  },

}